/** Shared CRM state phase labels – workflow (ServisAPP) + communication runtime. */

export const CRM_WORKFLOW_STATE_PHASES = Object.freeze([
  { name: 'ServiceState.Phase.Created', code: 'created' },
  { name: 'ServiceState.Phase.Approval', code: 'approval' },
  { name: 'ServiceState.Phase.SystemApproval', code: 'system_approval' },
  { name: 'ServiceState.Phase.Execution', code: 'execution' },
  { name: 'ServiceState.Phase.SystemExecution', code: 'system_execution' },
  { name: 'ServiceState.Phase.Inspection', code: 'inspection' },
  { name: 'ServiceState.Phase.SystemInspection', code: 'system_inspection' },
  { name: 'ServiceState.Phase.Closing', code: 'closing' },
]);

export const CRM_COMMUNICATION_STATE_PHASES = Object.freeze([
  { name: 'CrmState.Phase.Semaphore', code: 'semaphore' },
  { name: 'CrmState.Phase.Followup', code: 'followup' },
  { name: 'CrmState.Phase.Outcome', code: 'outcome' },
  { name: 'CrmState.Phase.OfferStatus', code: 'offer_status' },
]);

export const CRM_STATE_PHASES = Object.freeze([
  ...CRM_WORKFLOW_STATE_PHASES,
  ...CRM_COMMUNICATION_STATE_PHASES,
]);

export const CRM_STATE_PHASE_OPTIONS = CRM_STATE_PHASES.map((p) => ({
  labelKey: p.name,
  value: p.code,
}));

export function crmStatePhaseLabelKey(phaseCode) {
  const match = CRM_STATE_PHASES.find((p) => p.code === phaseCode);
  return match?.name || null;
}
